var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "vs-row",
        [
          _c(
            "vs-col",
            { staticClass: "mt-4", attrs: { "vs-w": "12" } },
            [
              _c("fb-paginacion", {
                attrs: { total: _vm.pagination.pages, max: 10 },
                model: {
                  value: _vm.page,
                  callback: function($$v) {
                    _vm.page = $$v
                  },
                  expression: "page"
                }
              })
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }